(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('[data-cc-reveal]');
  if (reveals.length) {
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Sticky header ---------- */
  var header = document.querySelector('.cc-header');
  if (header) {
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      header.classList.toggle('is-stuck', y > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Le tiroir mobile est géré dans sections/header.liquid — ne pas le dupliquer ici. */

  /* ---------- Tabs (produits) ---------- */
  document.querySelectorAll('[data-cc-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-cc-tab]');
    var panels = root.querySelectorAll('[data-cc-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-cc-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-cc-panel') !== target;
        });
      });
    });
  });

  /* ---------- Compteurs ---------- */
  var counters = document.querySelectorAll('[data-cc-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        cio.unobserve(el);
        var end = parseFloat(el.getAttribute('data-cc-count')) || 0;
        var dec = (String(end).split('.')[1] || '').length;
        var start = null;
        var dur = 1100;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (end * eased).toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Accordéon ---------- */
  document.querySelectorAll('[data-cc-accordion] .cc-acc__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      var open = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------- Carrousel avis ---------- */
  document.querySelectorAll('[data-cc-carousel]').forEach(function (root) {
    var track = root.querySelector('.cc-carousel__track');
    if (!track) return;
    root.querySelectorAll('[data-cc-carousel-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-cc-carousel-nav') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * Math.min(track.clientWidth * 0.8, 420), behavior: 'smooth' });
      });
    });
  });
})();
